import { Button } from '@assembly-js/design-system';
import { useTranslation } from 'react-i18next';

import type { SettingsBackLinkProps } from './SettingsBackLink';

export interface SettingsSaveBarProps {
  dirty: boolean;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
  /** Replaces "Save changes", e.g. "Create field". */
  saveLabel?: string;
  /** Keeps Cancel enabled while nothing has changed. */
  alwaysAllowCancel?: boolean;
  /** Holds Save off while the page has changes it can't save yet. */
  saveDisabled?: boolean;
  /** A back link in the page's top left, opposite the buttons. */
  back?: Omit<SettingsBackLinkProps, 'className'>;
}

export const SettingsSaveBar = ({
  dirty,
  saving,
  onSave,
  onCancel,
  saveLabel,
  alwaysAllowCancel,
  saveDisabled,
}: SettingsSaveBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex shrink-0 items-center gap-2">
      <Button
        variant="secondary"
        className="h-8 whitespace-nowrap"
        label={t(($) => $.common.cancel)}
        disabled={(!dirty && !alwaysAllowCancel) || saving}
        onClick={onCancel}
      />
      <Button
        className="h-8 whitespace-nowrap"
        label={saveLabel ?? t(($) => $.page_settings.save_bar.save_changes)}
        disabled={!dirty || saving || saveDisabled}
        loading={saving}
        onClick={onSave}
      />
    </div>
  );
};
